<template lang="pug">
include /../../s-pug/mixin-icon
.Input.InputSelect._mb05._py05._cursor-pointer._noSelect(v-on:click="toggle" :class="{'is-open': isOpen}")
   ._truncate._w100(v-if="selected") {{selected[listLabel]}}
   ._truncate._w100._c-grey-500(v-if="!selected") {{placeholder}}
   .Icon
      +icon({name: 'icon-cheveron-selection'})
   .Options(v-bind:style="{ maxHeight: maxHeight || '300px'}")
      .Options-option(v-for="item in listOptions" :key="item[listKey]" @click="selectOption(item)")
         ._truncate
            ._truncate._fs-1 {{item[listLabel]}}
            ._fs-05._mt025 {{item.blurb}}
</template>

<style lang="sass" scoped>
.Icon
   opacity: .8
   +wh(24px)
   display: inline
   svg
      width: 100%
      display: inline
      fill: currentColor
.InputSelect
   display: flex
   justify-space: between
   position: relative
   line-height: 1.3
   border-radius: $radius
.Options
   display: none
   position: absolute
   background-color: white
   +lr(-1px)
   top: 100%
   z-index: 100
   margin-top: 3px
   +boxShadow()
   border-radius: $radius
   overflow-y: auto
   +customScrollbars($grey-400)
.InputSelect.is-open
   .Options
      display: block
.Options-option
   display: block
   +px($s-075)
   +py($s-075)
   color: $grey-700
   text-decoration: none
   &:focus,
   &:hover
      background-color: $grey-050
      color: $grey-900
   &:first-of-type
      border-top-left-radius: $radius
      border-top-right-radius: $radius
   &:last-of-type
      border-bottom-left-radius: $radius
      border-bottom-right-radius: $radius
</style>

<script>
export default {
   props: {
      placeholder: {
         type: String,
      },
      listOptions: {
         type: Array,
      },
      listKey: {
         type: String,
      },
      listLabel: {
         type: String,
      },
      maxHeight: {
         type: String,
      },
      /**
       * When working with objects, the reduce
       * prop allows you to transform a given
       * object to only the information you
       * want passed to a v-model binding
       * or @input event.
       */
      reduce: {
         type: Function,
         default: option => option,
      },
   },
   data() {
      return {
         isOpen: false,
         selected: '',
      }
   },
   methods: {
      toggle() {
         this.isOpen = !this.isOpen
      },
      selectOption(item) {
         console.log('select!', item)
         this.selected = item
      },
   },
   mounted() {
      console.log('options: ', this.listOptions)
      console.log('listLabel: ', this.listLabel)
      console.log('maxHeight: ', this.maxHeight)
   },
}
</script>
